export default __webpack_public_path__ + "static/media/hht1_ep19_minisitcom_03.0315d2f9.png";